import $ from 'jquery'

export default {
    name: 'manage-patient',
    components: {},
    props: {
        patient_id: Number,
        toggler: Number
    },
    data() {
        return {
            patient: {
                country_suffix: '',
                patient_id: 0,
                matricule: "",
                civilite: "",
                nom: "",
                prenoms: "",
                email: "",
                date_naissance: "",
                lieu_de_naissance: "",
                sexe: "",
                profession: "",
                nationalite: "",
                numero_cni: "",
                numero_passeport: "",
                telephone: "",
                quartier: "",

                situation_matrimoniale: "",
                conjoint_nom: "",
                conjoint_prenoms: "",
                nombre_enfants: 0,

                type_patient: 'non_assure',
                le_malade: '',
                assur_principal_matricule: '',
                assur_principal_nom: '',
                assur_principal_prenom: '',
                assur_principal_sexe: '',
                assur_principal_phone: '',

                personne_a_prevenir_nom: "",
                personne_a_prevenir_prenom: "",
                personne_a_prevenir_profession: "",
                personne_a_prevenir_quartier: "",
                personne_a_prevenir_filiation: "",
                personne_a_prevenir_telephone: ""
            },
            info_loading: true,
            info_error: false,

            assur_selected: '',
            societe_selected: '',
            liste_societes: [],

            // Tel input placeholder config
            options: { placeholder: "Ex. 90 00 00 00", maxlength: 11 },
            tel_is_required: false,
            country_code: '',
            assure_country_code: '',
            pers_country_code: '',

            prefered_countries: [this.default_country_code],
            only_countries: ['tg', 'bj', 'ci', 'bf'],

            phone_is_exist: false,
            email_is_exist: false,
            is_error: false,

            save_loading: false
        }
    },

    watch: {
        assur_selected() {
            this.societe_selected = ''
            this.choixAssurance()
        },

        patient_id() {
            this.getInfoPatientById(this.patient_id)
        },

        toggler() {
            this.info_loading = true
            this.patient = {
                country_suffix: '',
                patient_id: 0,
                matricule: "",
                civilite: "",
                nom: "",
                prenoms: "",
                email: "",
                date_naissance: "",
                lieu_de_naissance: "",
                sexe: "",
                profession: "",
                quartier: "",
                nationalite: "",
                numero_cni: "",
                numero_passeport: "",
                telephone: "",

                situation_matrimoniale: "",
                conjoint_nom: "",
                conjoint_prenoms: "",
                nombre_enfants: 0,

                type_patient: 'non_assure',
                le_malade: '',
                assur_principal_matricule: '',
                assur_principal_nom: '',
                assur_principal_prenom: '',
                assur_principal_sexe: '',
                assur_principal_phone: '',

                personne_a_prevenir_nom: "",
                personne_a_prevenir_prenom: "",
                personne_a_prevenir_profession: "",
                personne_a_prevenir_quartier: "",
                personne_a_prevenir_filiation: "",
                personne_a_prevenir_phone: ""
            }

            this.fetcher()
        }
    },

    computed: {
        liste_sexes() {
            return this.$store.getters['liste_sexes']
        },

        liste_civilites() {
            return this.$store.getters['liste_civilites']
        },
        
        liste_situation_matrimoniales() {
            return this.$store.getters['liste_situation_matrimoniales'];
        },

        professions() {
            return this.$store.getters['professions'];
        },

        // assurances() {
        //     return this.$store.getters['assurances'];
        // },

        info_patient() {
            return this.$store.getters['info_patient'];
        },

        compagnie_assurances() {
            return this.$store.getters["assurances"];
        },

        souscripteurs() {
            return this.$store.getters["souscripteurs"];
        }, 

        liste_filiation() {
            return this.$store.getters["liste_filiation"];
        },
    },

    mounted() {
        this.patient.country_suffix = this.default_country_code
    },

    methods: {
        fetcher() {
            this.$store.dispatch("getSexes")

            this.$store.dispatch('getSituationsMatrimoniales')

            this.$store.dispatch('getListeCivilite')

            // Liste des assurances
            this.$store.dispatch("getAssurances")

            this.getListeFiliation()
        },

        getListeFiliation() {
            this.$store.dispatch('getListeFiliation', { data_type: 'filiation' })
        },

        getInfoPatientById(patient_id) {
            if (patient_id > 0) {
                this.$store.dispatch('getInfoPatient', patient_id).then(() => {
                    this.fillInfoPatient()
                }).catch(() => {
                    this.info_loading = false
                    this.info_error = true
                })
            }
        },

        fillInfoPatient() {
            let tmp_patient_tel = this.info_patient.patient_telephone_mobile
            tmp_patient_tel = tmp_patient_tel.split(" ")
            const patient_tel = tmp_patient_tel.slice(1).join(' ');

            let tmp_assur_tel = this.info_patient.assure_telephone
            tmp_assur_tel = tmp_assur_tel.split(" ")
            const assur_tel = tmp_assur_tel.slice(1).join(' ');

            let tmp_pers_tel = this.info_patient.personne_a_prevenir_telephone
            tmp_pers_tel = tmp_pers_tel.split(" ")
            const pers_tel = tmp_pers_tel.slice(1).join(' ');

            this.patient = {
                patient_id: this.info_patient.patient_id,
                matricule: this.info_patient.patient_matricule,
                nom: this.info_patient.patient_nom,
                prenoms: this.info_patient.patient_prenom,
                email: this.info_patient.patient_email,
                date_naissance: this.info_patient.patient_date_naissance,
                lieu_de_naissance: this.info_patient.patient_lieu_naissance,
                sexe: {
                    id: this.info_patient.patient_sexe_id,
                    specificatif: this.info_patient.patient_sexe
                },
                profession: this.info_patient.patient_profession,
                nationalite: this.info_patient.patient_nationalite,
                numero_cni: this.info_patient.patient_numero_cni,
                numero_passeport: this.info_patient.patient_numero_passeport,
                telephone: this.info_patient.patient_telephone_mobile,
                quartier: this.info_patient.patient_quartier,

                situation_matrimoniale: {
                    id: this.info_patient.patient_situation_matrimoniale_id,
                    descriptif: this.info_patient.patient_situation_matrimoniale
                },
                conjoint_nom: this.info_patient.patient_conjoint_nom,
                conjoint_prenoms: this.info_patient.patient_conjoint_prenoms,
                nombre_enfants: this.info_patient.patient_nombre_enfants,

                type_patient: (this.info_patient.est_assure == 0)?'non_assure':'assure',
                le_malade: this.info_patient.assure_est_luimeme,
                assur_principal_matricule: this.info_patient.assure_matricule,
                assur_principal_nom: this.info_patient.assure_nom,
                assur_principal_prenom: this.info_patient.assure_prenom,
                assur_principal_sexe: {
                    id: this.info_patient.assure_sexe_id,
                    specificatif: this.info_patient.assure_sexe
                },
                assur_principal_phone: this.info_patient.assure_telephone,

                personne_a_prevenir_nom: this.info_patient.personne_a_prevenir_nom,
                personne_a_prevenir_prenom: this.info_patient.personne_a_prevenir_prenom,
                personne_a_prevenir_profession: this.info_patient.personne_a_prevenir_profession,
                personne_a_prevenir_quartier: this.info_patient.personne_a_prevenir_quartier,
                personne_a_prevenir_filiation: {
                    champ_id: this.info_patient.personne_a_prevenir_filiation_id,
                    champ: this.info_patient.personne_a_prevenir_filiation
                },
                personne_a_prevenir_phone: this.info_patient.personne_a_prevenir_telephone
            }

            setTimeout(() => {
                this.patient.personne_a_prevenir_phone = pers_tel
                this.patient.telephone = patient_tel
                this.patient.assur_principal_phone = assur_tel
            }, 500);

            this.info_loading = false

            this.assur_selected = {
                id: this.info_patient.assurance_id,
                compagnie_assurance: this.info_patient.assurance
            }

            setTimeout(() => {
                this.societe_selected = {
                    id : this.info_patient.societe_id,
                    souscripteur: this.info_patient.societe
                }
            }, 1000);
            
        },

        choixAssurance() {
            let assurance_id = this.assur_selected.id

            if (assurance_id > 0) {
                this.$store.dispatch("getSocieteByAssurance", assurance_id).then(() => {
                    this.liste_societes = this.souscripteurs
                })
            } else {
                this.liste_societes = []
            }
        },

        /**
         * Clear Error message
         */
        clearError() {
            this.tel_is_required = false
            this.phone_is_exist = false
            this.email_is_exist = false
            this.is_error = false
        },

        countryChanged(country) {
            this.country_code = '+' + country.dialCode
        }, 

        assureCountryChanged(country) {
            this.assure_country_code = '+' + country.dialCode
        },

        persCountryChanged(country) {
            this.pers_country_code = '+' + country.dialCode
        },

        /**
         * Choix entre Patient assuré ou non
         */
        onAssurance() {
            if (this.patient.type_patient == 'assure') {
                // Le patient est assuré
                $('.est-assure').fadeIn(500)
            } else {
                // Le patient n'est pas assuré
                $('.est-assure').fadeOut(500)
            }
        },

        /**
         * Dis si le malade est : 
         * Lui même ou son Conjoint ou encore son enfant
         */
        assureLuiMeme() {
            let cbox = document.getElementById('lui-meme');

            if (cbox.checked) {         //  Il s'agit de Lui-même
                this.patient.assur_principal_matricule = this.patient.matricule
                this.patient.assur_principal_nom = this.patient.nom
                this.patient.assur_principal_prenom = this.patient.prenoms
                this.patient.assur_principal_sexe = this.patient.sexe
                this.patient.assur_principal_phone = this.patient.telephone
            }else {
                this.patient.assur_principal_matricule = ''
                this.patient.assur_principal_nom = ''
                this.patient.assur_principal_prenom = ''
                this.patient.assur_principal_sexe = ''
                this.patient.assur_principal_phone = ''
            }
        },


        savePatient: async function () {
            const isValid = await this.$refs.patient_form.validate();
            if (!isValid) {
                this.is_error = true
                return;
            }

            let p_tel = (this.patient.telephone != '')?(this.country_code+' '+this.patient.telephone):''
            let assur_tel = (this.patient.assur_principal_phone != '')?(this.assure_country_code+' '+this.patient.assur_principal_phone):''
            let pers_tel = (this.patient.personne_a_prevenir_phone != '')?(this.pers_country_code+' '+this.patient.personne_a_prevenir_phone):''

            let new_patient = {}
            
            new_patient = {
                country_suffix: this.patient.country_suffix,
                patient_id: (this.patient_id)?this.patient_id:0,
                malade_matricule: this.patient.matricule,
                nom: this.patient.nom,
                prenoms: this.patient.prenoms,
                email: this.patient.email,
                date_naissance: this.patient.date_naissance,
                lieu_de_naissance: this.patient.lieu_de_naissance,
                sexe: this.patient.sexe.id,
                profession: this.patient.profession,
                nationalite: this.patient.nationalite,
                numero_cni: this.patient.numero_cni,
                numero_passeport: this.patient.numero_passeport,
                telephone_mobile: p_tel,
                quartier: this.patient.quartier,

                situation_matrimoniale: this.patient.situation_matrimoniale.id,
                conjoint_nom: this.patient.conjoint_nom,
                conjoint_prenoms: this.patient.conjoint_prenoms,
                nombre_enfants: this.patient.nombre_enfants,

                assur_selected: this.assur_selected.id,
                societe_selected: this.societe_selected.id,

                type_patient: this.patient.type_patient,
                le_malade: this.patient.le_malade,
                assur_principal_matricule: this.patient.assur_principal_matricule,
                assur_principal_nom: this.patient.assur_principal_nom,
                assur_principal_prenom: this.patient.assur_principal_prenom,
                assur_principal_sexe: this.patient.assur_principal_sexe.id,
                assur_principal_phone: assur_tel,

                personne_a_prevenir_nom: this.patient.personne_a_prevenir_nom,
                personne_a_prevenir_prenom: this.patient.personne_a_prevenir_prenom,
                personne_a_prevenir_profession: this.patient.personne_a_prevenir_profession,
                personne_a_prevenir_quartier: this.patient.personne_a_prevenir_quartier,
                personne_a_prevenir_filiation: {
                    champ_id: this.patient.personne_a_prevenir_filiation.champ_id,
                    champ: this.patient.personne_a_prevenir_filiation.champ
                },
                personne_a_prevenir_phone: pers_tel
            },

            console.log("New Patient Data: ", new_patient);
            

            this.save_loading = true;

            this.$store.dispatch('savePatient', new_patient).then(
                (response) => {
                    if (response < 0) {
                        if (response == -1) {
                            this.phone_is_exist = true
                        } else if (response == -2) {
                            this.email_is_exist = true
                        }
                    } else {
                        this.successToast('Patient enregistré avec succès')
                        this.$refs.edit_patient.click();
                        this.$emit('emitPatient')
                    }
                    this.save_loading = false;
                }
            ).catch(() => {
                this.save_loading = false;
            })
        },
    }
}